import React, { useEffect, useRef, useState } from 'react'
import styled from 'styled-components';
import ModalSelect from '../../components/shared/ModalSelect';
import Input from '../../components/shared/Input';
import BaseModal from '../../components/shared/BaseModal';
import Button from '../../components/shared/Button';
import locationsAPI from '../../api/locationsAPI';
import useUpdateEffect from '../../hooks/useUpdateEffect';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: 1em 1.5em 0;
`
const FormSection = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 1.5em;
  &:nth-child(2){
    margin-bottom: 0em;
  }
`
const Subtitle = styled.div`
  font-family: Open Sans;
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 18px;
  letter-spacing: -0.01em;
  color: #333333;
  margin-bottom: 1em;
`

const ModalLocation = ({ visible, onClose, selectedLocation, onClick1, onClick2, store, error, changeError }) => {
  const [form, setForm] = useState({
    locationName: '',
    division: null,
    department: null,
    line: null,
    brand: null
  })
  const [divisionOPT, setDivisionOPT] = useState([])
  const [departmentOPT, setDepartmentOpt] = useState([])
  const [lineOPT, setLineOpt] = useState([])
  const [brandOPT, setBrandOPT] = useState([])
  const isInitialMountLine = useRef(true);
  const isInitialMountDepartment = useRef(true);

  // useEffect(() => {
  //   console.log('updating form', form)
  // }, [form])

  useEffect(() => {
    if(selectedLocation) {
      console.log('SELECTED LOCATION !!',selectedLocation)
      setForm({
        ...form,
        locationName: selectedLocation.name,
        division: {
          value: selectedLocation.divisionId,
          label: selectedLocation.divisionName
        },
        department: {
          value: selectedLocation.departmentId,
          label: selectedLocation.departmentName
        },
        line: selectedLocation.lineId ? {
          value: selectedLocation.lineId,
          label: selectedLocation.lineName
        } : null,
        brand: selectedLocation.brandId ? {
          value: selectedLocation.brandId,
          label: selectedLocation.brandName
        } : null
      })
    }
    // eslint-disable-next-line
  }, [visible])

  useEffect(() => {
    console.log('MOUNTING MODAL')
    fetchAllOPTS();
    // eslint-disable-next-line
  }, [])

  useUpdateEffect(() => {
    if(isInitialMountDepartment.current) isInitialMountDepartment.current = false;
    else setForm({...form, department: null})
    if(!selectedLocation) setForm({...form, department: null})
    if(form.division) fetchDepartments();
  }, [form.division])

  useUpdateEffect(() => {
    if(isInitialMountLine.current) isInitialMountLine.current = false;
    else setForm({...form, line: null})
    if(!selectedLocation) setForm({...form, line: null})
    if(form.department) fetchLines();
  }, [form.department])

  useUpdateEffect(() => {
    changeError()
  }, [form])

  const fetchAllOPTS = async () => {
    await Promise.all([fetchDivisions(), fetchBrands()])
  }

  const fetchDivisions = async () => {
    try {
      const data = await locationsAPI.getDivisions()
      const dataToSet = data.map(d => ({ value: d.cod_division, label: d.desc_division}))
      console.log('dataToSet MODALLLLLLLLLLLLLLLL :', dataToSet);
      setDivisionOPT(dataToSet)
    } catch(e) {
      console.log(e)
    }
  }

  const fetchDepartments = async () => {
    try {
      const data = await locationsAPI.getDepartments({ cod_division: form.division.value})
      const dataToSet = data.map(d => ({ value: d.cod_depto, label: d.desc_depto}))
      setDepartmentOpt(dataToSet)
    } catch (e) {
      console.log(e)
    }
  }

  const fetchLines = async () => {
    try {
      const data = await locationsAPI.getLines({ cod_depto: form.department.value })
      const dataToSet = data.map(d => ({ value: d.cod_linea, label: d.desc_linea}))
      setLineOpt(dataToSet)
    } catch (e) {
      console.log(e)
    }
  }

  const fetchBrands = async () => {
    try {
      const data = await locationsAPI.getBrands()
      const dataToSet = data.map(d => ({ value: d.cod_marca_odbms, label: d.desc_marca}))
      setBrandOPT(dataToSet)
    } catch (e) {
      console.log(e)
    }
  }

  const handleChange = async (evt, name) => {
    let newForm = { ...form }
    let value = evt?.target ? evt.target.value : evt;
    const key = evt?.target ? evt.target.name : name;
    console.log(value, key);
    setForm({
      ...newForm,
      [key]: value
    })
  }

  const checkDisabled = () => {
    let flag = false;
    // console.log('============================================== START ========================================================')
    for (let key of Object.keys(form)) {
      // console.log('form[key] :', form[key]);
      // console.log('key :', key);
      // console.log('if ()', (!(key !== 'line' || key !== 'brand') && (form[key] === '' || form[key] === null)));
      if(!(key === 'line' || key === 'brand') && (form[key] === '' || form[key] === null)) flag = true
    }
    // console.log('flag :', flag)
    // console.log('============================================== END ========================================================')
    return flag
  }

  return (
    <BaseModal
      title={!selectedLocation ? 'Agregar nueva ubicación' : 'Editar ubicación existente'}
      onClose={onClose}
      size="small"
      visible={visible}
    >
      <div className='modal-form-container'>
        <Container>
          <FormSection>
            <Subtitle>Ingresa la ubicación del ítem</Subtitle>
            <Input
              placeholder='Ubicación'
              name='locationName'
              value={form.locationName}
              onChange={handleChange}
              type='text'
              error={error.locationName}
            />
          </FormSection>
          <FormSection>
            <Subtitle>Selecciona las categorías del ítem</Subtitle>
            <ModalSelect
              label='División'
              name='division'
              value={form.division}
              options={divisionOPT}
              onChange={(e, value) => handleChange(value, 'division')}
            />
            <ModalSelect
              label='Departamento'
              name='department'
              disabled={!form.division}
              value={form.department}
              options={departmentOPT}
              onChange={(e, value) => handleChange(value, 'department')}
            />
            <ModalSelect
              label='Linea (opcional)'
              name='line'
              disabled={!form.department}
              value={form.line}
              options={lineOPT}
              onChange={(e, value) => handleChange(value, 'line')}
            />
            <ModalSelect
              label='Marca (opcional)'
              name='brand'
              value={form.brand}
              options={brandOPT}
              onChange={(e, value) => handleChange(value, 'brand')}
              error={error.brand}
            />
          </FormSection>
        </Container>
        <div className='modal-form-container-footer'>
          <Button
            text='Cancelar'
            type='secondary'
            onClick={onClick1}
          />
          <Button
            text={selectedLocation ? 'Editar' : 'Añadir'}
            type='primary'
            disabled={checkDisabled() || !store}
            onClick={() => {
              // const data = fields && fields.reduce((obj, field) => {
              //   obj[field] = eval(field)
              //   return obj
              // }, {})
              onClick2(form)
            }}
          />
        </div>
      </div>
    </BaseModal>
  )
}

export default ModalLocation

